class Accordion {
	constructor() {
		const accordions = document.querySelectorAll('.faq_ask');

		if (accordions != undefined || accordions !== null) {
			for (let index = 0; index < accordions.length; index++) {
				const accordion = accordions[index];

				accordion.addEventListener('click', () => {
					this.accordions(accordions, accordion);
				});
			}
		}
	}

	accordions(accordions, accordion) {
		for (var i = 0; i < accordions.length; ++i) {
			accordions[i].closest('.faq_row').classList.remove('active-faq');
		}

		var content = accordion.closest('.faq_row');
		content.classList.add('active-faq');
	}
}

export default Accordion;
